import { render } from "./Mascot.vue?vue&type=template&id=3bcfacd5&scoped=true"
import script from "./Mascot.vue?vue&type=script&lang=js"
export * from "./Mascot.vue?vue&type=script&lang=js"

import "./Mascot.vue?vue&type=style&index=0&id=3bcfacd5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcfacd5"]])

export default __exports__